import County from './County.model';

export default class RatingRegion {
  region_name: string;
  counties: Array<County>;
}
